import React, { useState, useEffect } from "react";
import "./footnav.css";
import { NavLink } from "react-router-dom";
// import schlogo from "../resources/images/School Crest.png";
import schlogo from '../resources/images/logo512.png'

function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(true);
  const [screenMode, setScreenMode] = useState(
    window.innerWidth <= 990 ? "small" : "large"
  );

  useEffect(() => {
    // fetchMessages()
    const updateScreenMode = () => {
      if (window.innerWidth <= 990) {
        setScreenMode("small");
      } else {
        setScreenMode("large");
      }
    };
    updateScreenMode();
    window.addEventListener("resize", updateScreenMode);
    return () => {
      window.removeEventListener("resize", updateScreenMode);
    };
  }, []);

  return (
    <div className="navbar">
      <div className="bg-pattern"></div>
      <div className="navcontent">
        <NavLink className="link">
          <div className="logo">
            <img src={schlogo} alt="" />
            {
              <span
                style={
                  screenMode === "large"
                    ? { fontSize: "1.5rem" }
                    : { fontSize: "1.2rem" }
                }
              >
                STAR OF THE EAST
              </span>
            }
          </div>
        </NavLink>
        {!toggleMenu && screenMode === "small" ? (
          <div
            onClick={() => {
              setToggleMenu(true);
            }}
            className="sideLinks-backfilter"
          ></div>
        ) : null}
        {
          <div
            className={screenMode === "large" ? "navlinks" : "sideLinks"}
            style={{
              width: toggleMenu && screenMode === "small" ? "0rem" : "20rem",
            }}
          >
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="/"
            >
              Home
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="/about"
            >
              About Us
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="/academics"
            >
              Academics
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="/contact"
            >
              Contact
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="/events"
            >
              Events
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="/scholarships"
            >
              Scholarships
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="/admissions"
            >
              Admission
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "link active" : "link")}
              to="https://www.softesc.online/"
            >
              Portal
            </NavLink>
          </div>
        }

        {screenMode === "small" ? (
          <div
            className="menu-icon"
            onClick={() => {
              {
                setToggleMenu(!toggleMenu);
              }
            }}
          >
            <div
              className="r1"
              style={
                toggleMenu
                  ? { transform: "rotate(0deg)", top: "0rem" }
                  : { transform: "rotate(-45deg)", top: "0.3rem" }
              }
            ></div>
            {toggleMenu ? <div className="r2"></div> : null}
            <div
              className="r3"
              style={
                toggleMenu
                  ? { transform: "rotate(0deg)", top: "0rem" }
                  : { transform: "rotate(45deg)", bottom: "0.3rem" }
              }
            ></div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
export default Navbar;
